import { ArrowBack } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ResetButton from '../../Common_Components/ResetButton';
import SaveButton from '../../Common_Components/SaveButton';
import CustomInputField from '../../Common_Components/CustomInputField';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import axiosInstance from '../../axios/axios';
import { Toast } from '../../Common_Components/Toast';

const AdduserRole = () => {
    const navigate = useNavigate(); // Hook for navigation
    // Handler for the back arrow click
    const handleBackClick = () => {
        navigate(-1); // Navigate back to the previous page
    };
    const [UserRole, setUserRole] = useState('')
    const [status, setStatus] = useState(null)
    const statusList = [
        { id: 1, label: 'Active' },
        { id: 0, label: 'Inactive' }
    ];
    const handleValidation = () => {
        // Validation checks for each field
        if (!UserRole) {
            Toast.warning('User role is required');
            return false;
        }
        if (!status) {
            Toast.warning('Status is required');
            return false;
        }

        return true; // Return true if no errors
    };
    const SaveUserRole = async (e) => {
        e.preventDefault();
        // Validate before submitting
        if (!handleValidation()) return;
        const request = {
            RL_Name: UserRole,
            RL_Status: status.id
        }
        const response = await axiosInstance.post('/users/addUserRole', request)
        const { success, message } = response.data
        if (success === true) {
            Toast.success(message)
            navigate(-1)
        } else {
            Toast.warning(message)
        }
    }
    return (
        <Box display="flex" padding={2} flexDirection="column" minHeight="100vh">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap">
                <Box display="flex" alignItems="center" mb={{ xs: 2, md: 0 }}>
                    <ArrowBack onClick={handleBackClick} style={{
                        cursor: 'pointer',
                        marginRight: '8px',
                        marginBottom: '5px',
                        height: '34px',
                        width: '38px',
                        color: '#545454',
                        border: '2.5px'
                    }} />
                    <Typography sx={{ fontFamily: 'Times New Roman', fontWeight: '700', fontSize: { xs: '24px', md: '32px' }, lineHeight: '36.8px', color: '#545454' }}>
                        Add User Role
                    </Typography>
                </Box>
                <Box>
                    <ResetButton label="Reset" />
                    <SaveButton label="Save" onClick={SaveUserRole} />
                </Box>
            </Box>

            <Paper elevation={3} sx={{ padding: { xs: 2, md: 4 } }}>
                <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2} justifyContent="center">
                    <Box flexBasis={{ xs: '100%', sm: '48%', md: '40%' }}>
                        <CustomInputField
                            label="User Role"
                            fullWidth
                            value={UserRole}
                            onChange={(e) => setUserRole(e.target.value)}
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', sm: '48%', md: '40%' }}>
                        <CustomSelectBox
                            label="Status"
                            options={statusList}
                            Value={status}
                            setValue={setStatus}
                        />
                    </Box>

                </Box>
            </Paper>
        </Box>
    )
}

export default AdduserRole